





























import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
@Component({
  components: {},
})
export default class Leave extends Vue {
  showTrainClassesModel: boolean = false;
  className: string = '';
  trainClasses: any = ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'];
  startDate: string | undefined = '';
  endDate: string | undefined = '';
  onConfirm(value: string) {
    this.className = value;
    this.showTrainClassesModel = false;
    this.$router.push('scheduleList');
  }

  onClickLeft() {
    this.$router.go(-1);
  }
  onClickRight() {
    this.$router.push('attendanceList');
  }
  onSubmit() {}
}
